import React, { useState, useEffect } from 'react';
import Icon from 'components/Icon';
import { PortalPopover } from 'components/Popover';
import { isFirstTime, markAsCompleted } from 'utils/firstTimeGuide';

type FirstTimeGuideKey =
  | 'CREATE_FROM_DRAWING'
  | 'CREATE_FROM_MEASUREMENT'
  | 'CREATE_FROM_TEMPLATE'
  | 'CREATE_FROM_SCRATCH';

type AddEstimateButtonProps = {
  guideKey: FirstTimeGuideKey;
  onAdd: () => void;
  canShow?: boolean;
};

const AddEstimateButton: React.FC<AddEstimateButtonProps> = ({
  guideKey,
  onAdd,
  canShow = true,
}) => {
  const [showFirstTimeGuide, setShowFirstTimeGuide] = useState(false);

  useEffect(() => {
    if (canShow && isFirstTime(guideKey)) {
      requestAnimationFrame(() => {
        setShowFirstTimeGuide(true);
      });
    }
  }, [canShow, guideKey]);

  const handleDismissGuide = () => {
    setShowFirstTimeGuide(false);
    markAsCompleted(guideKey);
  };

  return (
    <PortalPopover
      open={showFirstTimeGuide}
      onOpenChange={(open) => {
        setShowFirstTimeGuide(open);
        if (!open) {
          markAsCompleted(guideKey);
        }
      }}
      containerWidth="164px"
      trigger={
        <div
          className="flex items-center space-x-1 cursor-pointer"
          onClick={() => {
            if (showFirstTimeGuide) {
              handleDismissGuide();
            }
            onAdd();
          }}
        >
          <Icon name="plus" size={16} className="text-primary" />
          <span className="text-xs font-medium text-primary">Add Estimate</span>
        </div>
      }
    >
      <div>
        <div className="text-base font-semibold text-gray-900 mb-2">
          New! Multiple Estimates
        </div>
        <div className="text-xs text-gray-900">
          Create up to 6 estimates per job. Compare, upsell, and close faster.
        </div>
      </div>
    </PortalPopover>
  );
};

export default AddEstimateButton;
